import { kAccountDisabled, kROUser } from "../constants";
import { QDiagnosticOut } from "./QDiagnosticOut";
import { QUser } from "./QUser";
import { Globals } from "./Globals.js";

export class QUserMgr {
  constructor() {
    this.fUserList = null;
    this.fUsedSeats = null;
  }

  InitUserMgr() {
    this.fUserList = [];
  }

  GetUserCount() {
    return this.fUserList.length;
  }

  SetUserListFromJSON(JSONlist, updateList) {
    var wsMgr = Globals._wsMgr;
    var list = [];
    for (var aUserIdx in JSONlist) {
      var theUser = JSONlist[aUserIdx];
      var userObj = new QUser();
      userObj.fUserName = theUser["username"];
      userObj.fName = theUser["name"];
      userObj.fOrgName = theUser["org"];
      userObj.fUserEmail = theUser["email"];
      userObj.fMobile = theUser["mobile"];
      userObj.fStatus = theUser["status"];
      userObj.fUserType = theUser["role"];
      userObj.fDelegatedEmail = theUser["delegatedEmail"];
      userObj.SetIsDelegated(userObj.fDelegatedEmail != null);
      userObj.fGroupID = theUser["group"];
      userObj.SetMFAState(wsMgr, theUser);
      list.push(userObj);
    }

    if (updateList) this.fUserList = list;
    else return list;
  }

  UpdateUserInfo(newUserObj) {
    for (var aUserIdx in this.fUserList) {
      var theUserObj = this.fUserList[aUserIdx];
      if (
        theUserObj.fUserName === newUserObj.fUserName ||
        theUserObj.fUserName === newUserObj.fPrevUserID
      ) {
        this.fUserList[aUserIdx] = newUserObj;
        return;
      }
    }
    this.fUserList.push(newUserObj);
  }

  GetUserList() {
    return this.fUserList;
  }

  GetIndexUser(index) {
    return this.fUserList[index];
  }

  GetUsedSeats() {
    var c = 0;
    var n = this.GetUserCount();
    for (var i = 0; i < n; i++) {
      var u = this.GetIndexUser(i);
      if (u.GetUserRole() != kROUser && u.GetStatus() != kAccountDisabled) c++;
    }
    this.fUsedSeats = c;
    return c;
  }

  RemoveUsers(delUserList) {
    var u = delUserList.pop;
    while (u != null) {
      var index = this.fUserList.indexOf(u);
      if (index != -1) this.fUserList.splice(index, 1);
      u = delUserList.pop;
    }
  }

  ExportExcel(wsMgr, accessGroupMgr, userList) {
    var dOut = new QDiagnosticOut();
    var curOrg = wsMgr.GetAccountName();
    var curUser = wsMgr.GetUserName();
    var s = "UserList.xls";
    dOut.Init(curOrg, curUser, s, wsMgr);
    dOut.fHeaders = [
      "User Name",
      "Email",
      "Mobile",
      "Type",
      "Access Group ID",
      "Access Group",
      "MFA Status"
    ];

    var fieldData = [];
    for (var aHeader in dOut.fHeaders) fieldData.push({ name: dOut.fHeaders[aHeader], type: 0 });

    for (var i = 0; i < userList.length; i++) {
      var theUser = userList[i];
      var aRow = [];
      var uName = theUser.GetUserName();
      var uEmail = theUser.GetUserEmail();
      var uMobile = theUser.GetMobile();
      var uType = theUser.GetUserRole();
      var uGroupID = theUser.GetUserGroupID();
      var uAccessGroup = accessGroupMgr.GetGroupNameByID(uGroupID);
      var mfaState = theUser.GetMFAStateLabel();

      aRow.push(uName);
      aRow.push(uEmail);
      aRow.push(uMobile);
      aRow.push(uType);
      aRow.push(uGroupID);
      aRow.push(uAccessGroup);
      aRow.push(mfaState);

      dOut.AddDataRow(aRow);
    }

    var jsonData = {
      rows: dOut.fRowList,
      headers: dOut.fHeaders,
      headerLabels: dOut.fHeaders
    };
    jsonData["datatypes"] = fieldData;
    jsonData["filename"] = dOut.fFilename.replace(".xls", "");
    jsonData["sheetname"] = "User Information List";
    wsMgr.UploadExcelDataJSON(jsonData);
  }
}
